var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onClickLeft}},[(_vm.showRight)?[_c('van-icon',{attrs:{"name":"search","size":"18"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }